import { useState } from 'react';
import { useDataValidationV2 } from '../../../providers/DataValidationV2Provider';
import { ValidationStatus } from '../components/DataValidationTable/DataValidationTableFilters';
import { RuleItemStatus } from '../../../queries/types';

export type DataValidationListFilters = {
  search: string;
  category: string;
  validationStatus: string;
};

export const useDataValidationListData = () => {
  const { validationRulesLibrary } = useDataValidationV2();
  const [filters, setFilters] = useState<DataValidationListFilters>({
    search: '',
    category: 'all',
    validationStatus: ValidationStatus.ALL,
  });

  const filteredData =
    validationRulesLibrary?.filter((item) => {
      if (filters.search) {
        return item.displayName
          .toLowerCase()
          .includes(filters.search.toLowerCase());
      }

      if (filters.category !== 'all') {
        return item.categories?.includes(filters.category);
      }

      if (filters.validationStatus !== 'all') {
        if (
          filters.validationStatus === ValidationStatus.INACTIVE &&
          (item.status === RuleItemStatus.INACTIVE ||
            item.status === RuleItemStatus.INACTIVE_WITH_ERRORS ||
            !item.status)
        ) {
          return true;
        }

        if (filters.validationStatus === ValidationStatus.FAILED) {
          return item.status === RuleItemStatus.FAIL;
        }

        if (filters.validationStatus === ValidationStatus.SUCCESS) {
          return item.status === RuleItemStatus.SUCCESS;
        }

        return false;
      }

      return true;
    }) || [];

  const categories =
    validationRulesLibrary?.reduce<string[]>((acc, curr) => {
      if (curr.categories) {
        curr.categories.forEach((category) => {
          if (!acc.includes(category)) {
            acc.push(category);
          }
        });
      }

      return acc;
    }, []) || [];

  return {
    data: validationRulesLibrary,
    filteredData,
    categories,
    filters,
    setFilters,
  };
};
